import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const MEMBER_API_BASE = `${BACKEND_URL}/api`;

export const memberApi = axios.create({ baseURL: MEMBER_API_BASE });

memberApi.interceptors.request.use((config) => {
  const token = typeof window !== "undefined" ? localStorage.getItem("pp_member_token") : null;
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatMemberError(err) {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => d?.msg || JSON.stringify(d)).join(" ");
  if (detail?.msg) return detail.msg;
  return err?.message || "Something went wrong.";
}
